/**
 * Format payment data for table display
 * @param {Array} payments - Raw payment data from API
 * @returns {Array} Formatted payment data
 */
export const formatPayments = (payments) => {
  return payments.map(payment => ({
    key: payment.id,
    date: payment.created_at ? new Date(payment.created_at).toLocaleString() : 'N/A',
    total: payment.total ? `$${payment.total}` : 'N/A',
    coins: payment.coins_amount || 'N/A',
    status: payment.payment_status || 'N/A',
    invoice_url: payment.urls?.invoice_url || null,
    ...payment,
  }));
};

/**
 * Get product title by ID
 * @param {Array} products - List of products
 * @param {string} productId - Product ID to find
 * @returns {string} Product title or empty string if not found
 */
export const getProductTitleById = (products, productId) => {
  const product = products.find((p) => p.id === productId);
  return product?.title?.toLowerCase() || '';
};
